module.exports = __webpack_public_path__ + "static/media/hero-squares.c82d5df9.png";